import { CheckCircle } from 'lucide-react';

export default function SituationsSection() {
  const situations = [
    "Vous hésitez à embaucher parce que vous ne savez pas par où commencer",
    "Vous avez un conflit avec un salarié et vous ne savez pas comment le gérer",
    "Vous vous sentez perdu·e face à vos obligations d'employeur",
    "Vous devez licencier quelqu'un et vous avez peur de faire une erreur",
    "Vous cherchez un poste et votre CV ne vous représente pas",
    "Vous voulez négocier votre salaire mais vous ne savez pas comment faire"
  ];

  return (
    <section className="py-20 bg-white dark:bg-warm-gray-900 border-b border-aurore-light/20 dark:border-warm-gray-700">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-warm-gray-900 dark:text-warm-gray-100 mb-6 leading-tight">
              Vous êtes peut-être dans cette situation si…
            </h2>
            <p className="text-lg text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus">
              Ces questions vous parlent ? Parlons-en. Premier échange gratuit et sans engagement.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {situations.map((situation, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-aurore-pale dark:bg-warm-gray-800 rounded-2xl hover:bg-aurore-light/40 dark:hover:bg-warm-gray-700 transition-all duration-300"
              >
                <CheckCircle className="w-6 h-6 text-aurore-dark flex-shrink-0 mt-1" />
                <p className="text-warm-gray-800 dark:text-warm-gray-200 leading-relaxed">{situation}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center space-x-2 text-aurore-dark font-medium hover:text-aurore-medium transition-colors text-lg"
            >
              <span>Je veux en parler maintenant</span>
              <span className="text-2xl">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
